import React, { PureComponent } from 'react';
import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer
} from '../../components/ui';

import Image from '../../../../containers/assets/peer-feedback-teamword-skills.png'

class TeamworkSkills extends PureComponent {
  render() {
    return (
      <Wrapper>
        <PreTitle>Overview</PreTitle>
        <Title>Teamwork Skills</Title>
        <Text>
          <p>According to the <a href="https://www.naceweb.org/talent-acquisition/candidate-selection/the-attributes-employers-seek-on-students-resumes/" target="_blank" rel="noreferrer">National Association of Colleges and Employers</a>, teamwork skills are one of the most important soft skills that employers seek. Therefore, your instructor wants you to be aware of these skills and continuously develop/refine them throughout your college and career journey.</p>
        </Text>
        <ContentContainer>
          <img src={Image} alt='' />
        </ContentContainer>
        <Text>
          <p>Let’s walk through some of the teamwork skills that you’ve been demonstrating in this exercise.</p>
        </Text>
      </Wrapper>
    );
  }

}

export default TeamworkSkills;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/overview/teamworks-skills.js